import * as React from 'react';
import { IgcDropdownGroupComponent as Component } from 'igniteui-webcomponents';
import { createComponent } from '../react-props.js';

/**
 * A container for a group of `igc-dropdown-item` components.
 * @slot label - Contains the group's label.
 * @slot  - Intended to contain the items belonging to this group.
 * @csspart label - The native label element.
 * @class
 */
export const IgrDropdownGroup = /* @__PURE__ */ createComponent({
  tagName: 'igc-dropdown-group',
  displayName: 'IgrDropdownGroup',
  elementClass: Component,
  react: React,
});

export type IgrDropdownGroup = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrDropdownGroupModule = Component;
